// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"e8b30336","513":"5a642502","703":"283ec305","787":"a91d1337"}[chunkId] + ".chunk.js";
};